const getOrderHistory = state => {
  return state.orderHistory;
};

export default {
  getOrderHistory,
};
